// extracted by mini-css-extract-plugin
export default {"header":"Pagetitle_header__g7J58","headerIcons":"Pagetitle_headerIcons__SnUOJ","searcBox":"Pagetitle_searcBox__DGEKr"};